<template>
	<el-dialog title="积分兑换记录查询" :visible="visible" width="" center class="recharge-dialog"
		@update:visible="val => $emit('update:visible', val)">
		<div class="dialog-content">
			<!-- 充值记录筛选 -->
			<div class="filter-bar">
				<el-input v-model="filter.order_id" placeholder="充值单号" clearable prefix-icon="el-icon-search"
					class="search-input filter-item"></el-input>
				<el-date-picker v-model="filter.date_range" type="daterange" range-separator="至"
					start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable
					class="search-input filter-item date-range-item"></el-date-picker>
				<el-select v-model="filter.pay_type" placeholder="请选择渠道" clearable
					class="search-input filter-item select-item">
					<el-option label="微信" :value="1"></el-option>
					<el-option label="支付宝" :value="2"></el-option>
				</el-select>
				<el-select v-model="filter.recharge_type" placeholder="请选择支付类型" clearable
					class="search-input filter-item select-item">
					<el-option label="自动充值" :value="1"></el-option>
					<el-option label="手动充值" :value="2"></el-option>
				</el-select>
				<el-select v-model="filter.pay_status" placeholder="请选择支付状态" clearable
					class="search-input filter-item select-item">
					<el-option label="兑换成功" :value="1"></el-option>
					<el-option label="支付失败" :value="2"></el-option>
					<el-option label="待支付" :value="3"></el-option>
				</el-select>
				<el-button type="primary" class="search-btn" @click="handleSearch">查询</el-button>
				<el-button class="reset-btn" @click="handleReset">重置</el-button>
			<el-button class="reset-btn export-btn" icon="el-icon-download" :loading="exporting"
				@click="handleExport">{{ exportLabel }}</el-button>
			</div>
			<el-table :data="records" border style="width: 100%" v-loading="loading"
				:header-cell-style="{ 
			        background: '#f5f7fa',
			        color: '#606266',
			        fontWeight: '600',
			        fontSize: '14px'
			    }">
				<el-table-column prop="order_id" label="订单号" align="center" min-width="180"></el-table-column>
				<el-table-column prop="amount" label="积分数量" align="center" min-width="120">
					<template slot-scope="scope">
						<span style="color: #00C48C; font-weight: 500;">+{{ scope.row.amount }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="time" label="时间" align="center" min-width="180"></el-table-column>
				<el-table-column prop="pay_type" label="兑换渠道" align="center" min-width="100">
					<template slot-scope="scope">
						<el-tag :type="scope.row.pay_type === 1 ? 'success' : 'primary'" size="small" effect="plain">
							<i :class="scope.row.pay_type === 1 ? 'el-icon-wechat' : 'el-icon-alipay'" style="margin-right: 4px;"></i>
							{{ scope.row.pay_type_name }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="type" label="类型" align="center" min-width="100">
					<template slot-scope="scope">
						<el-tag :type="scope.row.recharge_type === 1 ? 'success' : 'primary'" size="small"
							effect="plain">
							{{ scope.row.type }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="pay_status" label="支付状态" align="center" min-width="120">
					<template slot-scope="scope">
						<el-tag :type="scope.row.pay_status === 1 ? 'success' : 
				             scope.row.pay_status === 2 ? 'danger' : 'warning'" size="small" effect="plain">
							{{ scope.row.pay_status_text }}
						</el-tag>
					</template>
				</el-table-column>
			</el-table>

			<!-- 空数据提示 -->
			<div class="empty-recharge" v-if="records.length === 0 && !loading">
				<i class="el-icon-document" style="font-size: 40px; color: #c0c4cc; margin-bottom: 12px;"></i>
				<p style="font-size: 14px; color: #909399; margin: 0;">暂无积分兑换记录</p>
			</div>

			<!-- 分页 -->
			<div class="recharge-pagination" v-if="total > 0">
				<el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
					:current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[10, 20, 50]"
					layout="total, sizes, prev, pager, next" :total="total" small></el-pagination>
			</div>
		</div>

		<span slot="footer" class="dialog-footer">
			<el-button @click="$emit('update:visible', false)" class="dialog-btn cancel-btn"
				style="margin-right: 80px;">关闭</el-button>
			<el-button type="primary" @click="handleRefresh" class="dialog-btn refresh-btn" :loading="loading">刷新记录</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { formatDateTime as fmtDateTime } from '../utils/format';
import { exportCSV } from '../utils/export';

export default {
	name: 'RechargeRecordsDialog',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		userId: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			loading: false,
			exporting: false,
			records: [],
			currentPage: 1,
			pageSize: 10,
			total: 0,
			filter: {
				order_id: '',
				date_range: [],
				pay_type: '',
				recharge_type: '',
				pay_status: ''
			}
		};
	},
	watch: {
		visible(val) {
			if (val) {
				this.loadRecords(1);
			}
		}
	},
	computed: {
		exportLabel() {
			return '导出 Excel（' + this.total + '）';
		}
	},
	methods: {
		async apiRequest(url, data) {
			const response = await fetch(url, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(data)
			});
			if (!response.ok) {
				throw new Error('请求失败: ' + response.status);
			}
			return response.json();
		},
		buildParams() {
			const range = this.filter.date_range || [];
			return {
				order_id: this.filter.order_id || '',
				time_start: range[0] || '',
				time_end: range[1] || '',
				pay_type: this.filter.pay_type,
				recharge_type: this.filter.recharge_type,
				pay_status: this.filter.pay_status
			};
		},
		async loadRecords(page) {
			if (page) this.currentPage = page;
			if (!this.userId || this.userId === 0) {
				this.$message.error('用户未登录或用户ID无效');
				return;
			}
			this.loading = true;
			try {
				const result = await this.apiRequest('/query_recharge', Object.assign({
					user_id: this.userId,
					page: this.currentPage,
					page_size: this.pageSize
				}, this.buildParams()));
				if (result.code === 200) {
					this.records = this.formatData(result.data.list || []);
					this.total = result.data.count || 0;
				} else {
					this.$message.error(result.msg || '查询失败');
				}
			} catch (error) {
				console.error('查询充值记录失败:', error);
				this.$message.error('网络错误或服务器异常，请稍后重试');
			} finally {
				this.loading = false;
			}
		},
		formatData(list) {
			return list.map(item => {
				const amount = parseFloat(item.recharge_amount || 0).toFixed(2);
				const rechargeType = parseInt(item.recharge_type || 1, 10);
				const payStatus = parseInt(item.pay_status || 1, 10);
				const payType = item.pay_type || 1;
				return {
					id: item.id,
					order_id: item.order_id || '',
					user_id: item.user_id,
					amount: amount,
					time: fmtDateTime(item.recharge_time),
					type: rechargeType === 1 ? '自动充值' : '手动充值',
					recharge_type: rechargeType,
					pay_status: payStatus,
					pay_status_text: payStatus === 1 ? '兑换成功' : payStatus === 2 ? '支付失败' : '兑换失败',
					pay_type: payType,
					pay_type_name: payType === 1 ? '微信' : '支付宝'
				};
			});
		},
		handleCurrentChange(page) {
			this.loadRecords(page);
		},
		handleSizeChange(size) {
			this.pageSize = size;
			this.loadRecords(1);
		},
		handleSearch() {
			this.loadRecords(1);
		},
		handleReset() {
			this.filter = {
				order_id: '',
				date_range: [],
				pay_type: '',
				recharge_type: '',
				pay_status: ''
			};
			this.loadRecords(1);
		},
		handleRefresh() {
			this.loadRecords(this.currentPage);
		},
		async handleExport() {
			if (this.exporting) return;
			this.exporting = true;
			try {
				const base = Object.assign({ user_id: this.userId, page_size: 100 }, this.buildParams());
				let all = [];
				let page = 1;
				let lastCount = 100;
				do {
					const result = await this.apiRequest('/query_recharge', Object.assign({}, base, { page }));
					const d = result.data || {};
					const list = d.list || [];
					all = all.concat(list);
					lastCount = list.length;
					page++;
					// 某页不足 100 条说明已到最后一页（不依赖 total，兼容后端分页统计差异）
				} while (lastCount === 100 && page <= 1000);
				const rows = all.map((it) => [
					it.order_id || '',
					parseFloat(it.recharge_amount || 0).toFixed(2),
					fmtDateTime(it.recharge_time),
					it.pay_type == 1 ? '微信' : '支付宝',
					parseInt(it.recharge_type || 1, 10) === 1 ? '自动充值' : '手动充值',
					parseInt(it.pay_status || 1, 10) === 1 ? '兑换成功'
						: parseInt(it.pay_status || 1, 10) === 2 ? '支付失败' : '兑换失败'
				]);
				exportCSV('积分兑换记录_' + Date.now() + '.csv',
					['订单号', '积分数量', '时间', '渠道', '类型', '支付状态'], rows);
			} catch (e) {
				this.$message.error('导出失败：' + e.message);
			} finally {
				this.exporting = false;
			}
		}
	}
};
</script>

<style scoped>
.recharge-dialog :deep(.el-dialog) {
	border-radius: 16px;
	overflow: hidden;
}
.recharge-dialog :deep(.el-dialog__header) {
	background: linear-gradient(135deg, #667eea, #764ba2);
	padding: 20px;
	text-align: center;
}
.recharge-dialog :deep(.el-dialog__title) {
	color: #fff;
	font-size: 18px;
	font-weight: 600;
}
.recharge-dialog :deep(.el-dialog__headerbtn .el-dialog__close) {
	color: #fff;
	font-size: 20px;
}
.recharge-dialog :deep(.el-dialog__body) {
	padding: 20px;
}
.recharge-dialog :deep(.el-dialog__footer) {
	padding: 15px 20px;
	border-top: 1px solid #f0f0f0;
	display: flex;
	justify-content: center;
	gap: 12px;
}
.dialog-btn.refresh-btn {
	background: linear-gradient(135deg, #667eea, #764ba2) !important;
	border: none !important;
	color: #fff !important;
}
.reset-btn.export-btn {
	background: #eaf4ff !important;
	border: 1px solid #a8c8f5 !important;
	color: #4a90e2 !important;
}
.reset-btn.export-btn:hover {
	background: #dcecff !important;
}
</style>
